'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isWeakSet(value) {
    return value instanceof WeakSet;
}

exports.isWeakSet = isWeakSet;
